<template>

    <div>
        <div class="player-filter">

            <div class="wrapper">

                <div class="player-filter__type">
                    <label class="vh" for="daySelector">Day Selector</label>
                    <select ref="daySelector" id="daySelector" name="daySelector" v-model="selectedDay">
                        <option value=""> All Days</option>
                        <option v-for="(day, dayIndex) in this.allDays" :value="day.value">
                            <!-- {{formatDate(day.value)}} --> 
                            {{formatDate(day.value)}}
                        </option>
                    </select>
                </div>

                <div class="player-filter__type">
                    <label class="vh" for="typeSelector">Type Selector</label>
                    <select ref="typeSelector" id="typeSelector" name="typeSelector" v-model="selectedType">
                        <option value=""> All Event Types</option>
                        <option v-for="(type, typeIndex) in this.types" :value="type.name">
                            {{ type.name }}
                        </option>
                    </select>
                </div>

            </div>

        </div>

        <div class="grid two wrapper">

                <activities-list-item 
                    v-for="(activity, activityIndex) in this.FilteredActivities" 
                    :activityItem="ensureActivityHasID(activity)" 
                    :key="activity.post_id" 
                    :show-favorite-button="true"
                    :star-full="starSvg" 
                >
                </activities-list-item>

        </div>

        <div class="wrapper">
            <div class="na" v-show="empty" style="margin-bottom: 40px">

                <h4 class="na__title" style="margin-bottom: 0">
                    No events match your criteria
                </h4>
            </div>
        </div>
    </div>

</template>


<script>
    import axios from 'axios';
    import ListItem from './ListItem.vue';
    // import Map from './Map.vue';

    export default {
        components: {
            'activities-list-item': ListItem,
        },

        data() {
            return {
                types:[],
                activities: null,
                allDays:null,
                selectedDay: "",
                selectedType:"",
                empty: false,
                starSvg: `<svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                </svg>`
            }
        },
        created() {
        },
        mounted () {
            axios.get('/wp-json/activities/v1/list')
                .then(response => {
                    this.types = response.data.terms;
                    
                    // Process activities to ensure proper IDs
                    if (response.data.activity && Array.isArray(response.data.activity)) {
                        // console.log('Activity data received:', response.data.activity.length, 'items');
                        // Log the first item to see its structure
                        if (response.data.activity.length > 0) {
                            // console.log('First activity sample:', response.data.activity[0]);
                        }
                        
                        // Ensure all activities have proper numeric IDs
                        this.activities = response.data.activity.map(activity => {
                            // Ensure the numeric post_id is available and consistent
                            if (activity.post_id) {
                                // Convert post_id to a numeric value if it's not already
                                const numericId = parseInt(activity.post_id, 10);
                                if (!isNaN(numericId)) {
                                    activity.post_id = numericId;
                                    // Also set the ID field to the same numeric value for consistency
                                    activity.id = numericId;
                                }
                            }
                            return activity;
                        });
                    } else {
                        this.activities = response.data.activity || [];
                    }
                    
                    this.allDays = this.period(this.activities);
                })
                .catch(error => {
                    console.error('Error fetching activities:', error);
                    this.activities = [];
                    this.types = [];
                    this.allDays = [];
                });

            let vm = this
            jQuery('#typeSelector').select2({
                width: '100%'
            }).on('change', function () {
                vm.selectedType = this.value
            })

            jQuery('#daySelector').select2({
                width: '100%'
            }).on('change', function () {
                vm.selectedDay = this.value
            })
        },
        watch:{
            FilteredActivities: function(newVal, oldVal) {

                if(this.FilteredActivities.length < 1){
                    this.empty = true;
                }else{
                    this.empty = false;
                }
            }

        },
        computed: {
            FilteredActivities: function () {

                let vm = this
                let items = this.activities
                
                // console.log('=== FILTER ACTIVITIES DEBUG ===');
                // if (items && items.length > 0) {
                //     console.log('First activity data:', {
                //         id: items[0].id,
                //         post_id: items[0].post_id,
                //         title: items[0].post_title,
                //         structure: Object.keys(items[0])
                //     });
                // }

                if(this.selectedType != 0){
                    items = items.filter(function(item){
                        var types = item.type
                        for (let i = 0; i < types.length; i++) {
                            if (vm.selectedType.includes(types[i].name)) {
                                return true;
                            }
                        }
                    })
                }

                if(this.selectedDay != 0){
                    return items.filter(function (item) {
                        if(vm.selectedDay.includes(item.acf.date)){
                            return vm.selectedDay.includes(item.acf.date)
                        }
                    }, this);
                }

                return items

            }
        },
        methods: {

            period(items) {

                const days = [];

                items.forEach((item) => {
                    const ActivityDate = item.acf.date;
                    const formattedWeekday = ActivityDate.toLocaleString('en-US', { weekday: 'short' }).toUpperCase();
                    const formattedDate = ActivityDate.toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });

                    // Check if the date already exists in the days array
                    const isDateExists = days.some((day) => day.value === formattedDate);

                    if (!isDateExists) {
                        const day = {
                            ActivityDate: ActivityDate.toLocaleString('en-US', { day: '2-digit' }),
                            weekday: formattedWeekday,
                            value: formattedDate
                        };

                        days.push(day);
                   }

                });

                return days

            },
            formatDate(dateString) {
                

                // const [month, day, year] = dateString.split('/');
                // const date = new Date(`${year}-${month}-${day}`);
                // const options = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' };
                // return date.toLocaleDateString('en-US', options).replace(/,/g, '').replace(/(\w+)\s(\w+)\s(\d+)/, '$1. $2. $3,');


                const [month, day, year] = dateString.split('/').map(Number);
                const date = new Date(year, month - 1, day);
                const options = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' };
                return new Intl.DateTimeFormat('en-US', options).format(date).replace(/,/g, '').replace(/(\w+)\s(\w+)\s(\d+)/, '$1. $2. $3,');
                ;
            },
            ensureActivityHasID(activity) {
                // Make a copy of the activity to avoid mutating the original
                const activityCopy = {...activity};
                
                // Debug the current state
                // console.log('Activity before ID check:', { 
                //     id: activityCopy.id,
                //     post_id: activityCopy.post_id
                // });
                
                // Ensure the activity has an ID
                if (!activityCopy.id && activityCopy.post_id) {
                    activityCopy.id = activityCopy.post_id;
                } else if (!activityCopy.post_id && activityCopy.id) {
                    activityCopy.post_id = activityCopy.id;
                }
                
                // Debug the updated state
                // console.log('Activity after ID check:', { 
                //     id: activityCopy.id,
                //     post_id: activityCopy.post_id
                // });
                
                return activityCopy;
            }
        },
    }

</script>
